class PointTransaction {
  public readonly name: string;
  public readonly displayDetail: string;
  public readonly transactedAt: Date;
  public readonly point: number;
  constructor({
    name,
    displayDetail,
    transactedAt,
    point,
  }: {
    name: string;
    displayDetail: string;
    transactedAt: Date;
    point: number;
  }) {
    this.name = name;
    this.displayDetail = displayDetail;
    this.transactedAt = transactedAt;
    this.point = point;
  }

  public static fromJSON = (value: any) => {
    const { name, display_detail, transacted_at, point } = Object.assign({}, value);

    if (typeof name !== 'string') throw new TypeError('.name must be a string');
    if (typeof display_detail !== 'string') throw new TypeError('.display_detail must be a string');
    if (typeof transacted_at !== 'string' || new Date(transacted_at).toString() === 'Invalid Date')
      throw new TypeError('.transacted_at must be a string');
    if (typeof point !== 'number') throw new TypeError('.point must be a number');

    return new PointTransaction({
      name: name,
      displayDetail: display_detail,
      transactedAt: new Date(transacted_at),
      point,
    });
  };
}

export default PointTransaction;
